import { render, staticRenderFns } from "./TestimonialsRatings.vue?vue&type=template&id=45ef6b66&"
import script from "./TestimonialsRatings.vue?vue&type=script&lang=js&"
export * from "./TestimonialsRatings.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialsRatings.vue?vue&type=style&index=0&id=45ef6b66&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports